<template>
    <form :inert="isLoading" :class="{'ajax_processed': isLoading}" @submit.prevent="onSubmit">
        <div class="bl_reg_form clearfix">
            <div class="checkbox f_checkbox f_checkbox_horizontal">
                <input id="discount-disallow-register" type="checkbox" v-model="formData.disallow_register">
                <label for="discount-disallow-register"><span></span> Активировать карту без регистрации в личном кабинете</label>
            </div>
            <div class="bl_reg_form_col">
                <div class="form_row form-item required" :class="{'error': v$.formData.lastName.$errors.length}">
                    <label for="discount-last-name" class="control-label">Фамилия<span class="req">*</span></label>
                    <input id="discount-last-name" type="text" class="form-control form-item required" v-model="formData.lastName">
                </div>
                <div class="form_row form-item required" :class="{'error': v$.formData.name.$errors.length}">
                    <label for="discount-name" class="control-label">Имя<span class="req">*</span></label>
                    <input id="discount-name" type="text" class="form-control form-item required" v-model="formData.name">
                </div>
                <div class="form_row form-item required" :class="{'error': v$.formData.secondName.$errors.length}">
                    <label for="discount-second-name" class="control-label">Отчество<span class="req">*</span></label>
                    <input id="discount-second-name" type="text" class="form-control form-item required" v-model="formData.secondName">
                </div>
                <div class="form_row form-item required" :class="{'error': v$.formData.cardNum.$errors.length}">
                    <label for="discount-card-num" class="control-label">Штрих-код карты (13 цифр)<span class="req">*</span></label>
                    <input id="discount-card-num" type="text" class="form-control form-item required" v-model="formData.cardNum" data-mask-card>
                </div>
            </div>
            <div class="bl_reg_form_col">
                <div class="form_row form-item required" :class="{'error': v$.formData.phone.$errors.length}">
                    <label for="discount-phone" class="control-label">Контактный телефон<span class="req">*</span></label>
                    <input id="discount-phone" type="text" class="form-control form-item required" v-model="formData.phone" data-mask-phone>
                </div>
                <template v-if="!formData.disallow_register">
                    <div class="form_row form-item required" :class="{'error': v$.formData.user_email.$errors.length}">
                        <label for="discount-email" class="control-label">E-mail<span class="req">*</span></label>
                        <input id="discount-email" type="text" class="form-control form-item required" v-model="formData.user_email">
                    </div>
                    <div class="form_row form-item required" :class="{'error': v$.formData.user_password.$errors.length}">
                        <label for="discount-password" class="control-label">Пароль<span class="req">*</span></label>
                        <input id="discount-password" type="text" class="form-control form-item required" v-model="formData.user_password">
                    </div>
                    <div class="form_row form-item required" :class="{'error': v$.formData.user_password_confirm.$errors.length}">
                        <label for="discount-confirm-password" class="control-label">Подтверждение пароля<span class="req">*</span></label>
                        <input id="discount-confirm-password" type="text" class="form-control form-item required" v-model="formData.user_password_confirm">
                    </div>
                </template>
            </div>
            <div class="form_row_send">
              <div class="consent-accepted" v-if="confirmConsent">Согласие на обработку персональных данных принято</div>
            </div>
            <div class="form_row_send">
              <div v-if="!confirmConsent" class="confirm-consent  confirm-consent--discount">
                  <div class="confirm-consent__text">
                      Подтвердите <a href="/upload/Согласие.pdf" target="_blank">согласие</a> на обработку <br> Ваших персональных
                      данных
                  </div>
                  <div class="confirm-consent__btn">
                      <button class="btn btn_red" type="button" @click="confirmConsent = true">Подтвердить</button>
                  </div>
              </div>
              <div v-else class="consent-block consent-block--discount">
                    <div class="consent-final__text">
                        Нажимая кнопку, Вы подтверждаете, что ознакомились с <a href="/upload/Политикa-конфиденциальности.pdf"
                            target="_blank">Политикой
                            конфиденциальности</a>
                    </div>
                    <div class="consent-final__btn">
                        <div class="not-theme">
                            <input type="submit" name="iblock_submit" value="Активировать карту" class="btn btn_red">
                        </div>
                    </div>
              </div>
            </div>
            
            <div class="agree_info">
                <div class="form_personal_data_accept">
                    <slot></slot>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {useVuelidate} from '@vuelidate/core'
import {required, email, helpers, minLength, sameAs} from '@vuelidate/validators'
import initMasks from '../../utils/masks.js';
const {withMessage} = helpers;
import {objectToFormData} from '../../utils/objectToFormData.js';

export default {
    name: 'DiscountActivationForm',
    props: {
        items: {
            type: Object,
            default: () => ([]),
        }
    },
    setup() {
        return {v$: useVuelidate(), initMasks}
    },
    data: () => ({
        formData: {
            disallow_register: false,
            name: '',
            lastName: '',
            secondName: '',
            phone: '',
            cardNum: '',
            user_password: '',
            user_password_confirm: '',
            user_email: '',
        },
        isLoading: false,
        confirmConsent: false,
    }),
    validations() {
        const rules = {
            formData: {
                lastName: {
                    required: withMessage('Обязательное поле', required)
                },
                name: {
                    required: withMessage('Обязательное поле', required)
                },
                secondName: {
                    required: withMessage('Обязательное поле', required)
                },
                cardNum: {
                    required: withMessage('Обязательное поле', required),
                    custom: withMessage('Обязательное поле', (value) => value.replace(/\D+/g, "").length === 13),
                },
                phone: {
                    required: withMessage('Обязательное поле', required),
                    minLength: withMessage('Введите корректный телефон', minLength(18)),
                },
                user_email: {},
                user_password: {},
                user_password_confirm: {},
            }
        }
        if (!this.formData.disallow_register) {
            rules.formData.user_email = {
                required: withMessage('Обязательное поле', required),
                email: withMessage('Введите корректный e-mail', email),
            };
            rules.formData.user_password = {
                required: withMessage('Обязательное поле', required),
            };
            rules.formData.user_password_confirm = {
                required: withMessage('Обязательное поле', required),
                sameAs: withMessage('Обязательное поле', sameAs(this.formData.user_password)),
            };
        }

        return rules;
    },
    mounted() {
        this.initMasks();
    },
    computed: {
        ...mapGetters({
            getYandexSiteKey: 'getYandexSiteKey',
        })
    },
    watch: {},
    methods: {
        async onSubmit() {
            const isValid = await this.v$.$validate();
            if (!isValid) return
            this.isLoading = true;
            const isCaptchaStarted = await this.executeYandexCaptcha(() => this.sendForm());
            if (!isCaptchaStarted) {
                this.isLoading = false;
                window.showHeaderMessage('Не удалось загрузить проверку. Перезагрузите страницу и попробуйте ещё раз.', 'error');
            }
        },
        clearForm() {
            this.v$.$reset();
            this.formData = {
                disallow_register: false,
                name: '',
                lastName: '',
                secondName: '',
                phone: '',
                cardNum: '',
                user_password: '',
                user_password_confirm: '',
                user_email: '',
            };
            this.confirmConsent = false;
        },
        async sendForm() {
            try {
                const result = await fetch('/api/forms/discount-activation/', {
                    method: 'POST',
                    body: objectToFormData({...this.formData, yatoken: window.smartCaptcha.getResponse()}),
                });
                const data = await result.json();
                if (data.success) {
                    window.showHeaderMessage('Заявка успешно принята. Карта будет активна через 3 дня после ее активации.');
                    this.clearForm();
                } else {
                    window.showHeaderMessage(data.error || 'Произошла ошибка', 'error');
                }
            } catch (error) {
                window.showHeaderMessage(error || 'Произошла ошибка', 'error');
            } finally {
                this.isLoading = false;
            }
        },
        ...mapActions({
            'executeYandexCaptcha': 'executeYandexCaptcha',
        }),
    },
}
</script>
